<template>
    <div v-if="params.data" class="flex gap-2">
        <template v-if="subAccountUuid">
            <sacc-link-resolver :uuid="subAccountUuid" :sub-account-name="transactionLine.subAccountName" :is-customer="isCustomer" />
        </template>
    </div>
</template>

<script setup lang="ts">

import {TransactionLine} from '@/types/transaction/TransactionLine'
import {computed, provide} from 'vue'
import SaccLinkResolver from '@/textTokenizer/SaccLinkResolver.vue'
import {CUSTOMER_ACCOUNT_NO} from '@/bookkeeping-account/accountTypes'

const props = defineProps({
    params: {
        type: Object as () => {
            data: TransactionLine,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const transactionLine = computed(() => {
    return props.params.data
})

const isCustomer = computed(() => {
    return transactionLine.value.accountNo === CUSTOMER_ACCOUNT_NO
})

const subAccountUuid = computed(() => {
    return transactionLine.value.subAccountUuid
})

</script>

<style scoped>

</style>